(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suveran-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('suveran-home')) {
    class SuveranHome extends HTMLElement {
      connectedCallback() {
        if (this.dataset.suveranReady === 'true') return;
        this.dataset.suveranReady = 'true';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.controller = new AbortController();
        this.frame = 0;
        this.cursorFrame = 0;

        this.revealItems = this.querySelectorAll(
          '.suveran-editorial__heading, .suveran-editorial figure, .suveran-section-heading, .suveran-creed li, .suveran-pillars__heading, .suveran-pillars article, .suveran-universe__grid a, .suveran-heading-row, .suveran-product-card, .suveran-empty-products, .suveran-origin__grid, .suveran-preorder-flow li, .suveran-diaspora__grid, .suveran-manifest__inner, .suveran-newsletter__grid'
        );

        if (this.reducedMotion) {
          this.revealItems.forEach((item) => item.classList.add('suveran-in'));
          return;
        }

        this.setupReveals();
        this.setupScrollThread();
        this.setupCursorThread();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.revealObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.cursorFrame) cancelAnimationFrame(this.cursorFrame);
      }

      setupReveals() {
        this.revealItems.forEach((item) => item.classList.add('suveran-reveal'));
        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('suveran-in');
              this.revealObserver.unobserve(entry.target);
            });
          },
          { threshold: 0.12 }
        );
        this.revealItems.forEach((item) => this.revealObserver.observe(item));
      }

      setupScrollThread() {
        this.progress = this.querySelector('[data-suveran-progress]');
        this.thread = this.querySelector('[data-suveran-thread]');
        this.threadPath = this.thread?.querySelector('path');
        if (!this.progress || !this.thread || !this.threadPath) return;

        const update = () => {
          const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
          const documentProgress = documentHeight > 0 ? window.scrollY / documentHeight : 0;
          this.progress.style.transform = `scaleX(${Math.min(1, Math.max(0, documentProgress))})`;

          const top = this.getBoundingClientRect().top + window.scrollY;
          const sectionProgress = (window.scrollY + window.innerHeight * 0.85 - top) / this.scrollHeight;
          const visible = Math.min(1, Math.max(0, sectionProgress));
          this.threadPath.style.clipPath = `inset(0 0 ${(1 - visible) * 100}% 0)`;
        };

        const queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            update();
          });
        };

        const buildThread = () => {
          const width = this.clientWidth;
          const height = this.scrollHeight;
          const step = 700;
          const amplitude = Math.min(width * 0.44, 560);
          const center = width / 2;
          let path = `M ${center + amplitude} 40`;

          for (let y = step; y <= height; y += step) {
            const direction = (y / step) % 2 === 1 ? -1 : 1;
            path += ` C ${center - direction * amplitude} ${y - step * 0.5}, ${center + direction * amplitude} ${y - step * 0.5}, ${center + direction * amplitude} ${y}`;
          }

          this.thread.setAttribute('viewBox', `0 0 ${width} ${height}`);
          this.threadPath.setAttribute('d', path);
          update();
        };

        buildThread();
        window.addEventListener('scroll', queueUpdate, { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', buildThread, { passive: true, signal: this.controller.signal });
        this.resizeObserver = new ResizeObserver(buildThread);
        this.resizeObserver.observe(this);
      }

      setupCursorThread() {
        if (!window.matchMedia('(pointer: fine)').matches || window.innerWidth < 990) return;
        const canvas = this.querySelector('[data-suveran-cursor]');
        const context = canvas?.getContext('2d');
        if (!canvas || !context) return;

        let points = [];
        let mouseX = -100;
        let mouseY = -100;

        const resize = () => {
          const ratio = Math.min(window.devicePixelRatio || 1, 2);
          canvas.width = window.innerWidth * ratio;
          canvas.height = window.innerHeight * ratio;
          canvas.style.width = `${window.innerWidth}px`;
          canvas.style.height = `${window.innerHeight}px`;
          context.setTransform(ratio, 0, 0, ratio, 0, 0);
        };

        window.addEventListener(
          'pointermove',
          (event) => {
            mouseX = event.clientX;
            mouseY = event.clientY;
          },
          { passive: true, signal: this.controller.signal }
        );
        window.addEventListener('resize', resize, { passive: true, signal: this.controller.signal });
        resize();

        const draw = () => {
          const head = points[points.length - 1] || { x: mouseX, y: mouseY };
          const next = {
            x: head.x + (mouseX - head.x) * 0.35,
            y: head.y + (mouseY - head.y) * 0.35
          };
          points.push(next);
          if (points.length > 28) points.shift();
          context.clearRect(0, 0, window.innerWidth, window.innerHeight);

          if (points.length > 2) {
            context.beginPath();
            context.moveTo(points[0].x, points[0].y);
            for (let index = 1; index < points.length - 1; index += 1) {
              context.quadraticCurveTo(
                points[index].x,
                points[index].y,
                (points[index].x + points[index + 1].x) / 2,
                (points[index].y + points[index + 1].y) / 2
              );
            }
            context.strokeStyle = 'rgba(163, 22, 33, 0.48)';
            context.lineWidth = 1.5;
            context.setLineDash([7, 6]);
            context.stroke();
            context.setLineDash([]);
            context.fillStyle = '#a31621';
            context.save();
            context.translate(next.x, next.y);
            context.rotate(Math.PI / 4);
            context.fillRect(-3, -3, 6, 6);
            context.restore();
          }

          this.cursorFrame = requestAnimationFrame(draw);
        };

        draw();
      }
    }

    customElements.define('suveran-home', SuveranHome);
  }

  } catch(e) { console.error(e); }
})();
})();
